import React from 'react'
import { Text } from '@UILibrary/Text'
import { Icon } from '@UILibrary/Icon'
import { Stack } from '@UILibrary/Stack'
import styles from './dataplaceholder.module.sass'

interface DataPlaceholderProps {
  textAlign?: 'left' | 'center' | 'right'
  message?: string
}

export const DataPlaceholder = ({
  textAlign = 'center',
  message = "We're still waiting for information"
}: DataPlaceholderProps) => {
  return (
    <Stack
      vertical
      alignItems="center"
      spacing="xs"
      padding="m"
      className={styles.container}
    >
      <Icon name="projector-board" size="large" />
      <Text body as="p" textAlign={textAlign} style={{ width: '100%' }}>
        {message}
      </Text>
    </Stack>
  )
}
